class BlogPostsFilter {
  public tabFilters: NodeListOf<HTMLElement> | null;
  public postCategories: NodeListOf<HTMLElement> | null;

  cache() {
    this.tabFilters = document.querySelectorAll('.js-blog-post-filter');
    this.postCategories = document.querySelectorAll('.js-m-blog-teaser__category');
  }

  bindings() {
    if (this.postCategories) {
      this.postCategories.forEach((postCategory: HTMLElement) => {
        postCategory.addEventListener('click', () => {
          const categoryId: string | undefined = postCategory.dataset.blogCategory;

          (document.querySelector(`[data-category-id="${categoryId}"]`) as HTMLElement)?.click();
          const scrollY = (document.querySelector('.o-tabs__headings-wrapper') as HTMLElement)?.offsetTop ?? null;
          // console.log('scrollY', scrollY);
          if (scrollY) {
            window.scrollTo({ top: scrollY - 100, left: 0, behavior: 'smooth'});
          }
        });
      });
    }
  }

  init() {
    this.cache();
    this.bindings();
  }
}

export default BlogPostsFilter;
